import { get } from '../Services/http';
import { catchError } from './Error.action';
import {
  receiveProductsWrapper,
  setCurrentProductsCount,
  setTotalProducts,
} from './LoadMore.action';
import {
  FACETED_SEARCH_QUERY,
  FACETED_SEARCH_RECEIVE,
  FACETED_SEARCH_ERROR,
  FACETED_SEARCH_TOGGLE_VALUE,
  FACETED_SEARCH_TOGGLE_COMPACT,
  PRODUCT_VIEW_CACHED,
  PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  MCS_STRUCTURE_UPDATE,
  MCS_ROOTPAGE_UPDATE,
  MCS_ROOTTITLE_UPDATE,
  MCS_METAROOTTITLE_UPDATE
} from '../constants';
import { pushEcommerce } from '../Services/Gtm.service';

export const query = (
  queryString = '',
  withHtmlResult = true,
  productsViewCachedId = new Date().getTime() + '',
  shouldDispatchToLoadMore = true
) => (dispatch, getState) => {
  let url = withHtmlResult
    ? '/api/productFilter/withHtmlResult'
    : '/api/productFilter';
  if (queryString && queryString.trim() !== '') {
    url += `?${queryString}`;
  }
  return get(url)
    .then((response) => response.json())
    .then((result) => {
      const { productsView, sortCriteria, subNavigation, ...others } = result;
      const productsWrapper = result.products;
      if (withHtmlResult) {
        dispatch(receiveProductsWrapper(result.products));
      }
      result = {
        ...others,
        sortCriteria,
        subNavigation,
        productsViewCachedId,
      };

      if (shouldDispatchToLoadMore) {
        dispatch(setCurrentProductsCount(productsWrapper.products.length));
      }

      dispatch(setTotalProducts(productsWrapper.pagination.totalCount));
      dispatch(receive(result));

      try {
        if (result.gtmViewModel !== null) {
          pushEcommerce(result.gtmViewModel);
        }
      } catch (err) {
        console.log(err);
      }
    })
    .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))));
};

export const ModifyResultForMCS = (filterCriteria, mcsStructure, rootpageUrl, rootPageTitle, rootPageDescription, rootPageMetaTitle, query, dispatch) => { //MCS

  const q = filterCriteria.join(';');
  var filters = q.replaceAll('=', ':');
  var cleanedFilters = decodeURIComponent(filters);
  var jsonArray = JSON.parse(mcsStructure);

  if(!jsonArray) { jsonArray = [] };

  var matchingPageByFilter = jsonArray.find(obj => obj.Filter == cleanedFilters);
  var matchingMCSPage = matchingPageByFilter ?  matchingPageByFilter : null;

  if(matchingMCSPage && matchingMCSPage.Url && cleanedFilters !== ""){
      var separator = window.location.href.replace(window.location.search, '').endsWith('/') || matchingMCSPage.Url.startsWith('/') ? '' : '/';
      const url = window.location.origin + rootpageUrl + separator +  matchingMCSPage.Url;   
      if(window.location.pathname !== matchingMCSPage.Url){
          window.history.pushState('search', 'Search Page', url);
          var header = document.getElementById('mcs-current-category-header');
          if(header){
              header.innerHTML = matchingMCSPage.Title;
          }
          var ingress = document.getElementById('mcs-current-category-description');
          if(ingress){
              ingress.innerHTML = matchingMCSPage.Description;
          }
          document.title = matchingMCSPage.MetaTitle;
      }
  }else{
      if(rootpageUrl){
          const url = window.location.origin + rootpageUrl + `${query?'?':''}${query}`;
          if(url != window.location.href){
              
              window.history.pushState('search', 'Search Page', url);

              var header = document.getElementById('mcs-current-category-header');
              if(header){
                  header.innerHTML = rootPageTitle;
              }
              var ingress = document.getElementById('mcs-current-category-description');
              if(ingress){
                  ingress.innerHTML = rootPageDescription;
              }
              //metadata
              document.title = rootPageMetaTitle;
          }
      }else{
          if(!matchingMCSPage){
              dispatch(saveQuery(query));
          }   
      }     
  }   
}

const toReducedGroupedFilters = (flattenedUrlParameters) => {
  const reducedGroupedFilters = flattenedUrlParameters.reduce(
    (result, filter) => {
      const prefixGroupName = filter.split('=')[0];
      const value = filter.split('=')[1];
      result[prefixGroupName] = result[prefixGroupName] || [];
      result[prefixGroupName].push(value);
      return result;
    },
    {}
  );
  return reducedGroupedFilters;
};

const toGroupedFilters = (reducedGroupedFilters, groups) => {
  let groupedFilters = [];

  Object.keys(reducedGroupedFilters).filter((groupName) => {
    var sortedFilterGroup = reducedGroupedFilters[groupName].sort(
      (a, b) => a - b
    );
    let groupIsSlider = groups.find((group) => group.id == groupName)?.asSlider;
    if (groupIsSlider) {
      if (sortedFilterGroup.length == 1) {
        groupedFilters.push(
          `${groupName}=${sortedFilterGroup[0] + '-' + sortedFilterGroup[0]}`
        );
      } else {
        groupedFilters.push(`${groupName}=${sortedFilterGroup.join('-')}`);
      }
    } else {
      reducedGroupedFilters[groupName].forEach((y) =>
        groupedFilters.push(`${groupName}=${y}`)
      );
    }
  });

  return groupedFilters;
};

const toGroupedFilterCriteria = (flattenedUrlParameters, groups) => {
  let groupedFilters = [];
  var reducedGroupedFilters = toReducedGroupedFilters(flattenedUrlParameters);
  if (reducedGroupedFilters != null) {
    return toGroupedFilters(reducedGroupedFilters, groups);
  }
  return groupedFilters;
};

export const getFacetFiltersAsQuery = (facetFilters) => {
  const filterCriteria = toFilterCriteria(facetFilters);
  const groupedFilterCriteria = toGroupedFilterCriteria(
    filterCriteria,
    facetFilters
  );
  const filterIds = facetFilters.map((filter) => filter.id);
  const ignoredParams = ['page'];
  const unChangedParams = (window.location.search.substr(1) || '')
    .split('&')
    .filter((param) => {
      const [id, value] = param.split('=');
      return (
        param.length > 0 &&
        !filterIds.includes(id) &&
        !ignoredParams.includes(id)
      );
    });
  return [...unChangedParams, ...groupedFilterCriteria].join('&');
};

const submit = (facetFilters) => (dispatch, getState) => {
  const q = getFacetFiltersAsQuery(facetFilters);

  const structure = getState().facetedSearch.mcsStructure;
  const rootPageUrl = getState().facetedSearch.mcsRootPageUrl;
  const rootPageTitle = getState().facetedSearch.mcsRootPageTitle;
  const rootPageMetaTitle = getState().facetedSearch.mcsRootPageMetaTitle;
  const rootPageDescription = getState().facetedSearch.mcsRootPageDescription
  const filterCriteria = toFilterCriteria(facetFilters);

  ModifyResultForMCS(filterCriteria, structure, rootPageUrl, rootPageTitle, rootPageDescription, rootPageMetaTitle, q, dispatch); //MCS
  return dispatch(query(q));
};

const toFilterCriteria = (groups) =>
  groups
    .map((group) =>
      group.selectedOptions
        .filter((val) =>
          group.asSlider
            ? group.selectedOptions.length == 2
            : val && val.length > 0
        )
        .map(
          (val) => `${encodeURIComponent(group.id)}=${encodeURIComponent(val)}`
        )
    )
    .reduce((flat, current) => [...flat, ...current], []);

/**
 *
 * @param filter : the group has changed facet
 * @param option : changed facet
 */
export const searchFacetChange = (filter = null, option = null) => (
  dispatch,
  getState
) => {
  if (filter) {
    const allFilters = getState().facetedSearch.facetFilters;
    let newFilters = [];
    if (filter.asSlider) {
      newFilters = updateSliderFilterOptions(allFilters, filter, option);
    } else {
      newFilters = updateFilterOption(allFilters, filter, option);
    }
    return dispatch(submit(newFilters));
  }
};

export const updateFilterOption = (
  allFilters = [],
  filter = null,
  option = null
) => {
  if (!filter) return allFilters;
  const filterIndex = allFilters.findIndex((f) => f.id === filter.id);
  const newFilter = option
    ? toggleFilterValue(filter, option)
    : { ...filter, selectedOptions: [] };
  const newFilters = [
    ...allFilters.slice(0, filterIndex),
    newFilter,
    ...allFilters.slice(filterIndex + 1),
  ];
  return newFilters;
};

export const updateSliderFilterOptions = (
  allFilters = [],
  filter = null,
  option = []
) => {
  if (!filter) return allFilters;
  const filterIndex = allFilters.findIndex((f) => f.id === filter.id);

  let filterCopy = filter;
  filterCopy.selectedOptions = option;
  const newFilters = [
    ...allFilters.slice(0, filterIndex),
    filterCopy,
    ...allFilters.slice(filterIndex + 1),
  ];
  return newFilters;
};

const toggleFilterValue = (filter, option) => {
  const { singleSelect, selectedOptions } = filter;
  const optionIndex = selectedOptions.indexOf(option.id);
  const newSelectedOptions =
    optionIndex < 0
      ? // not yet selected, select it
        singleSelect
        ? [option.id]
        : [...selectedOptions, option.id]
      : // selected, deSelect  it
        [
          ...selectedOptions.slice(0, optionIndex),
          ...selectedOptions.slice(optionIndex + 1),
        ];
  return { ...filter, selectedOptions: newSelectedOptions };
};

export const submitSearchFacet = (allFilters) => (dispatch, getState) => {
  dispatch(facetClientChanged(allFilters));
  return dispatch(submit(allFilters));
};

export const facetClientChanged = (facetFilters) => ({
  type: FACETED_SEARCH_TOGGLE_VALUE,
  payload: {
    facetFilters,
  },
});

export const toggleVisibleDropdownMenu = ({ id }) => ({
  type: FACETED_SEARCH_TOGGLE_COMPACT,
  payload: {
    visibleDropdownMenu: id,
  },
});

export const searchError = (error) => ({
  type: FACETED_SEARCH_ERROR,
  payload: {
    error,
  },
});

export const receive = (payload) => {
  return {
    type: FACETED_SEARCH_RECEIVE,
    payload,
  };
};

export const saveQuery = (queryString) => ({
  type: FACETED_SEARCH_QUERY,
  payload: {
    query: queryString,
  },
});

export const setProductsInProductsView = (products) => ({
  type: PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  payload: {
    productsWrapper: {
      products,
    },
  },
});

//MCS actions
export const saveMCSStructure = (structure) =>({
  type: MCS_STRUCTURE_UPDATE,
  payload: {
      mcsStructure: structure,
  }
})

export const saveMCSRootPageUrl = (rootPageUrl) =>({
  type: MCS_ROOTPAGE_UPDATE,
  payload: {
      mcsRootPageUrl: rootPageUrl,
  }
})

export const saveMCSRootPageTitle = (rootPageTitle) =>({
  type: MCS_ROOTTITLE_UPDATE,
  payload: {
      mcsRootPageTitle: rootPageTitle,
  }
})
export const saveMCSRootPageDescription = (rootPageDescription) =>({
  type: MCS_ROOTTITLE_UPDATE,
  payload: {
      mcsRootPageDescription: rootPageDescription,
  }
})
export const saveMCSRootPageMetaTitle = (rootPageMetaTitle) =>({
  type: MCS_METAROOTTITLE_UPDATE,
  payload: {
      mcsRootPageMetaTitle: rootPageMetaTitle,
  }
})

export const onSortCriteriaChanged = (query) => (dispatch, getState) => {
  const facetedSearchState = getState().facetedSearch;
  const sortCriteria = facetedSearchState.sortCriteria;
  const selectedItem = sortCriteria?.sortItems.find((i) => i.query == query);
  if (!selectedItem) return;
  const sortQuery = new URLSearchParams(selectedItem.query);
  const currentQuery = new URLSearchParams(location.search);
  const sortBy = sortQuery.get('sort_by');
  const sortDirection = sortQuery.get('sort_direction');
  if (!!sortBy) {
    currentQuery.set('sort_by', sortBy);
    currentQuery.set('sort_direction', sortDirection);
  } else {
    currentQuery.delete('sort_by');
    currentQuery.delete('sort_direction');
  }
  history.pushState('sort', null, '?' + currentQuery.toString());
  dispatch(submitSearchFacet(facetedSearchState.facetFilters));
};

export const clearFilterGroup = (filterGroupId) => (dispatch, getState) => {
  const facetFilters = getState().facetedSearch.facetFilters;
  const filtersCopy = Object.assign([], facetFilters);
  const filterGroup = filtersCopy.find((f) => f.id == filterGroupId);
  if (!filterGroup) return;
  filterGroup.selectedOptions = [];
  dispatch(submitSearchFacet(filtersCopy));
};

export const clearAllFilters = () => (dispatch, getState) => {
  const facetFilters = getState().facetedSearch.facetFilters;
  const filtersCopy = Object.assign([], facetFilters);
  for (let filter of filtersCopy) {
    filter.selectedOptions = [];
  }
  dispatch(submitSearchFacet(filtersCopy));
};
